export const outletConstants = {
    OUTLET_LIST_REQUEST: 'OUTLET_LIST_REQUEST',
    OUTLET_LIST_SUCCESS: 'OUTLET_LIST_SUCCESS',
    OUTLET_LIST_ERROR: 'OUTLET_LIST_ERROR',
};